import { v7 as uuidv7 } from 'uuid';

export function newUUID(): string {
    return uuidv7();
}
